import { render, staticRenderFns } from "./PlayerRecords.vue?vue&type=template&id=ffbdbe26&scoped=true&"
import script from "./PlayerRecords.vue?vue&type=script&lang=js&"
export * from "./PlayerRecords.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRecords.vue?vue&type=style&index=0&id=ffbdbe26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbdbe26",
  null
  
)

export default component.exports